import { Box } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
import { ClickableCard } from './ClickableCard';
import { DraggableCard } from './DraggableCard';
import { StandardCard } from './StandardCard';
import { getCardColors } from './cardColors';
import { CardIcon } from './components';
export const LargeIconCard = (props) => {
    const Card = props.onSetMoving || props.onPointerDragStart ? DraggableCard : props.onCardClick ? ClickableCard : StandardCard;
    const ref = React.useRef(null);
    const [pointerDragging, setPointerDragging] = React.useState(false);
    const cardIcon = (React.createElement(Box, { sx: {
            position: 'absolute',
            top: 1,
            left: 1,
        } },
        React.createElement(CardIcon, Object.assign({}, props, { large: true }))));
    return (React.createElement(Box, { sx: { position: 'relative', transform: props.moving ? 'rotate(2deg)' : 'none' } },
        React.createElement(Card, Object.assign({}, props, { onPointerDragStart: (point) => {
                const pointerDragStarted = props.onPointerDragStart ? props.onPointerDragStart(point) : false;
                if (pointerDragStarted) {
                    setPointerDragging(true);
                }
                return pointerDragStarted;
            }, onPointerDragEnd: (point) => {
                var _a;
                setPointerDragging(false);
                (_a = props.onPointerDragEnd) === null || _a === void 0 ? void 0 : _a.call(props, point);
            }, onPointerDragCancel: () => {
                var _a;
                setPointerDragging(false);
                (_a = props.onPointerDragCancel) === null || _a === void 0 ? void 0 : _a.call(props);
            }, renderDragCard: (dragCard, dragCardSx) => (React.createElement(Box, { sx: [{ position: 'relative' }, ...(Array.isArray(dragCardSx) ? dragCardSx : [dragCardSx])] },
                dragCard,
                cardIcon)), getCardBoundingRect: () => {
                const element = ref.current;
                if (element) {
                    element.style.transform = 'none';
                    const rect = element.getBoundingClientRect();
                    element.style.transform = '';
                    return rect;
                }
                else {
                    return undefined;
                }
            }, sx: {
                transform: 'none',
            } }),
            React.createElement(Box, { sx: {
                    display: 'grid',
                    gridTemplateColumns: 'auto 1fr',
                    color: themeColors.decorative.white,
                    backgroundColor: getCardColors()[props.color],
                    borderTopLeftRadius: 4,
                    borderTopRightRadius: 4,
                } },
                React.createElement(Box, { sx: {
                        width: 94,
                        minHeight: 80,
                    } }),
                React.createElement(Box, { sx: { alignSelf: 'center', overflow: 'hidden' } }, props.header)),
            React.createElement(Box, { sx: { alignSelf: 'center', overflow: 'hidden' } }, props.children)),
        !pointerDragging && cardIcon));
};
